import api from '@/services/Api';
import Impferinnerungstext from '@/types/Impferinnerungstext';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { Impferinnerungstextart, ImpferinnerungstexteState, RootState } from '@/store/types';
import { DataResponse } from '@/types';

export type ImpferinnerungstexteFilter = { gueltig: string };
export type LoadImpferinnerungstextePayload = { filter: ImpferinnerungstexteFilter };
export type UpdateImpferinnerungstextPayload =
    { impferinnerungstext: Impferinnerungstext; filter: ImpferinnerungstexteFilter };
export type DeleteImpferinnerungstextPayload =
    { impferinnerungstext: Impferinnerungstext; filter: ImpferinnerungstexteFilter };

export type LoadImpferinnerungstexteData = DataResponse<Partial<Impferinnerungstext>[], {
    platzhalter: string[];
}>;
export type LoadImpferinnerungstextartenData = DataResponse<Impferinnerungstextart[]>;

type Context = ActionContext<ImpferinnerungstexteState, RootState>;

export const impferinnerungstexte: Module<ImpferinnerungstexteState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            impferinnerungstexte: false,
            arten: false,
        },
        impferinnerungstexte: [],
        platzhalter: [],
        arten: [],
    },
    actions: {
        loadImpferinnerungstexte({ commit }: Context, payload?: LoadImpferinnerungstextePayload): void {
            commit('setLoadersImpferinnerungstexte', true);

            api.post('verwaltung/impferinnerungstexte/load', payload)
                .then((response: AxiosResponse) => commit('setImpferinnerungstexte', response.data))
                .catch(console.error)
                .finally(() => commit('setLoadersImpferinnerungstexte', false));
        },
        updateImpferinnerungstext({ commit, dispatch }: Context,
                                  { impferinnerungstext, filter }: UpdateImpferinnerungstextPayload): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/impferinnerungstexte/speichern', impferinnerungstext)
                .then(() => {
                    successSwal('Impferinnerungstext', 'gespeichert');
                    dispatch('loadImpferinnerungstexte', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteImpferinnerungstext({ commit, dispatch }: Context,
                                  { impferinnerungstext, filter }: DeleteImpferinnerungstextPayload): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/impferinnerungstexte/loeschen', impferinnerungstext)
                .then(() => {
                    successSwal('Impferinnerungstext', 'gelöscht');
                    dispatch('loadImpferinnerungstexte', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
        loadImpferinnerungstextarten({ commit }: Context): void {
            commit('setLoadersImpferinnerungstextarten', true);

            api.post('verwaltung/impferinnerungstexte/arten')
                .then((response: AxiosResponse) => commit('setImpferinnerungstextarten', response.data))
                .catch(console.error)
                .finally(() => commit('setLoadersImpferinnerungstextarten', false));
        },
    },
    mutations: {
        setImpferinnerungstexte(state: ImpferinnerungstexteState,
                                { body, selections }: LoadImpferinnerungstexteData): void {
            state.impferinnerungstexte = body.map((data) => new Impferinnerungstext(data));
            state.platzhalter = selections.platzhalter;
        },
        setImpferinnerungstextarten(state: ImpferinnerungstexteState,
                                    { body }: LoadImpferinnerungstextartenData): void {
            state.arten = body;
        },
        setDialogsDetail(state: ImpferinnerungstexteState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: ImpferinnerungstexteState, loading: boolean): void {
            state.loaders.save = loading;
        },
        setLoadersDelete(state: ImpferinnerungstexteState, loading: boolean): void {
            state.loaders.delete = loading;
        },
        setLoadersImpferinnerungstexte(state: ImpferinnerungstexteState, loading: boolean): void {
            state.loaders.impferinnerungstexte = loading;
        },
        setLoadersImpferinnerungstextarten(state: ImpferinnerungstexteState, loading: boolean): void {
            state.loaders.arten = loading;
        },
    },
};
